import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { authStore } from "./AuthStore";
import { PositionedSpinner } from "../../components/ui/PositionedSpinner";

export const AuthInit: React.FC<ReactProps> = ({ children }) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchToken = async () => {
      if (isAuthenticated) {
        const token = await getAccessTokenSilently();
        authStore.setAccessToken(token);
        setIsLoading(false);
      }
    };

    fetchToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isLoading]);

  if (isLoading) {
    return <PositionedSpinner />;
  }
  return <>{children}</>;
};
